import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";
import type { YearOnYearByPortParams, YearOnYearTrendParams } from "./types";

// Service prefix matches the panel-filter lookup URLs and api.yaml servers
// (…/isce/booking-volume-performance), NOT bare /booking-volume.
const baseURL = `${import.meta.env.VITE_API_BASE_URL}/booking-volume-performance/booking-volume/year-on-year`;

/**
 * Serialises params into a query string: drops null/undefined/empty-array
 * values and explodes arrays into repeated keys (`explode: true` in api.yaml),
 * mirroring the carrier-performance query builder.
 */
const toQueryString = (params: YearOnYearTrendParams | YearOnYearByPortParams): string =>
  new URLSearchParams(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0))
      .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]]))
  ).toString();

/** GET /booking-volume/year-on-year/trend — Chart 5, YoY by period. */
const getYearOnYearTrend = (params: YearOnYearTrendParams, config?: AxiosRequestConfig) =>
  apiBase("get", `${baseURL}/trend?${toQueryString(params)}`, config);

/** GET /booking-volume/year-on-year/by-port — Chart 6, YoY by port / port-pair. */
const getYearOnYearByPort = (params: YearOnYearByPortParams, config?: AxiosRequestConfig) =>
  apiBase("get", `${baseURL}/by-port?${toQueryString(params)}`, config);

export { getYearOnYearTrend, getYearOnYearByPort, toQueryString };
export * from "./types";
